/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { I18nInfoParameters } from './I18nInfoParameters';
import {
    I18nInfoParametersFromJSON,
    I18nInfoParametersFromJSONTyped,
    I18nInfoParametersToJSON,
} from './I18nInfoParameters';

/**
 * 
 * @export
 * @interface I18nInfo
 */
export interface I18nInfo {
    /**
     * 
     * @type {string}
     * @memberof I18nInfo
     */
    key?: string | null;
    /**
     * 
     * @type {I18nInfoParameters}
     * @memberof I18nInfo
     */
    parameters?: I18nInfoParameters | null;
    /**
     * 
     * @type {string}
     * @memberof I18nInfo
     */
    $type?: I18nInfoTypeEnum;
}


/**
 * @export
 */
export const I18nInfoTypeEnum = {
    PtwPtw100SharedUtilitiesExceptionsI18nInfoPtwPtw100SharedUtilities: 'Ptw.Ptw100.SharedUtilities.Exceptions.I18nInfo, Ptw.Ptw100.SharedUtilities'
} as const;
export type I18nInfoTypeEnum = typeof I18nInfoTypeEnum[keyof typeof I18nInfoTypeEnum];



/**
 * Check if a given object implements the I18nInfo interface.
 */
export function instanceOfI18nInfo(value?: unknown): value is I18nInfo {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(I18nInfoTypeEnum)[0];
}

export function I18nInfoFromJSON(json: any): I18nInfo {
    return I18nInfoFromJSONTyped(json, false);
}

export function I18nInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): I18nInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'parameters': json['parameters'] == null ? undefined : I18nInfoParametersFromJSON(json['parameters']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function I18nInfoToJSON(value?: I18nInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'key': value['key'],
        'parameters': I18nInfoParametersToJSON(value['parameters']),
        '$type': value['$type'],
    });
}

